import type { RequisitionItem } from "../../services/requisitionApi";

export const isCustomerSeedItem = (item: RequisitionItem) =>
  !item.inputId && !!item.seedBatchId;

export const getRequisitionItemType = (item: RequisitionItem) => {
  if (isCustomerSeedItem(item)) return "Customer Seed";
  if (item.isExternalItem) return "External";
  return "Store Input";
};

export const getRequisitionItemName = (item: RequisitionItem) => {
  if (isCustomerSeedItem(item)) return "Customer Seed";
  return item.inputName || "Store Item";
};

export const getRequisitionItemDescription = (item: RequisitionItem) => {
  if (isCustomerSeedItem(item)) {
    return item.inputName && item.inputName !== item.seedBatchNumber
      ? item.inputName
      : undefined;
  }
  return undefined;
};

export const getRequisitionItemReference = (item: RequisitionItem) => {
  if (isCustomerSeedItem(item)) {
    return item.seedBatchNumber
      ? `Batch ${item.seedBatchNumber}`
      : item.sowingInstructionNumber
        ? `Sowing ${item.sowingInstructionNumber}`
        : "-";
  }

  return item.inputCode
    ? `Reference ${item.inputCode}`
    : item.orderNumber
      ? `Order ${item.orderNumber}`
      : "-";
};

export const getRequisitionItemOwner = (item: RequisitionItem) => {
  if (isCustomerSeedItem(item)) {
    return item.seedOwnerName || item.seedBatchCustomerName || "Customer";
  }
  return "Company";
};

export const getRequisitionItemSource = (item: RequisitionItem) => {
  if (isCustomerSeedItem(item)) return "Customer batch";
  if (item.isExternalItem) return "Store Manager";
  return "In store";
};
